import React from 'react';
import T from 'i18n-react';

const Amount = ({onChange}) => (
    <div className="form-group row">
        <label className="col-sm-4 amount">
          <T.text tag='span' text="amount_fld"/>
        </label>
        <div className="col-sm-8">
            <select className="form-control inp-select" onChange={onChange}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
            </select>
        </div>
    </div>
);
export default Amount;



// WEBPACK FOOTER //
// ./src/components/creditCard/Amount.js